import React, { useEffect, useRef, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import { useLocation, useParams } from "react-router-dom";
import { FieldArray, getIn } from "formik";
import { SchedulingModalInner } from "./SchedulingModalInner";
import { SchedulingModalInnerView } from "./SchedulingModalInnerView";
import { SchedulingModalInnerEdit } from "./SchedulingModalInnerEdit";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
};
export default function AddSalesSubOrder() {
  const { adminDetails } = PagesIndex.useSelector(
    (state) => state.AdminReducer
  );

  const formRef = useRef();
  const formRefOrder = useRef();
  const formRefOrderEdit = useRef();
  const params = useParams();
  const location = useLocation();
  const { id } = params;
  const orderList = location?.state?.orderList;
  const navigate = PagesIndex.useNavigate();
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState({});
  const [editId, setEditId] = useState("");
  const [docData, setDocData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buttonSpinner, setButtonSpinner] = useState(false);
  const [openSave, setOpenSave] = useState(false);
  const [openDiscard, setOpenDiscard] = useState(false);
  const [creativeAdded, setCreativeAdded] = useState(false);
  const [openUploadDocument, setOpenUploadDocument] = useState(false);
  const [openCalenderStart, setOpenCalenderStart] = useState(false);
  const [openCalenderEnd, setOpenCalenderEnd] = useState(false);
  const [prevBookingsData, setPrevBookingsData] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);
  const [creativeList, setCreativeList] = useState([]);
  const [programData, setProgramData] = useState([]);
  const [weekArray, setWeekArray] = useState([]);
  const [activityLog, setActivityLog] = useState([]);
  const [activityLoading, setActivityLoading] = useState(true);
  const [openLogModal, setOpenLogModal] = useState(false);
  const totalAmount = data?.reduce((total, item) => {
    if (item?.unit == "seconds") {
      return (
        total + parseFloat((item?.units * item?.discountrate) / 10 || 0, 10)
      );
    } else {
      return total + parseFloat(item?.units * item?.discountrate || 0, 10);
    }
  }, 0);
  useEffect(() => {
    handleGetSalesOrder();
    handleGetCreative();
    handleGetProgram();
  }, []);
  const handleGetCreative = () => {
    PagesIndex.apiGetHandler(
      PagesIndex.Api.GET_CREATIVES_BY_CLIENT +
        "/" +
        location?.state?.orderList?.client?._id
    ).then((res) => {
      if (res?.status === 200) {
        setCreativeList(
          res?.data?.getCreative?.filter(
            (data) => data?.isActive && !data?.isDeleted
          )
        );
      }
    });
  };
  const handleGetProgram = () => {
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_PROGRAM).then((res) => {
      if (res.status === 200) {
        const program = res?.data?.filter((program) => program?.isActive);
        setProgramData(program);
      }
    });
  };
  const handleOpenUploadDocument = () => {
    setOpenUploadDocument(true);
  };
  const handleCloseUploadDocument = () => {
    formRef.current.resetForm();
    setOpenUploadDocument(false);
  };

  const renderImage = (values) => {
    const isUploadImg = values.image;
    const isImageBlob = values.image instanceof Blob;
    let src;
    let image = values.image.type?.includes("image");
    let video = values.image.type?.includes("video");
    let xmlimage = values.image.type?.includes("xml");
    if (image == false && video == false) {
      src = PagesIndex.Svg.pdfIcon;
    } else if (isImageBlob) {
      src = URL.createObjectURL(values.image);
    } else {
      src = PagesIndex.Svg.fileupload;
    }
    return (
      <img
        className={
          image && !xmlimage && isUploadImg
            ? "upload-img"
            : "upload-profile-img"
        }
        src={src}
        alt="document"
      />
    );
  };

  const clientInitialValues = {
    name: orderList?.subOrder?.name,
    startDate: orderList?.subOrder?.startDate
      ? PagesIndex.dayjs(orderList?.subOrder?.startDate)
      : null,
    endDate: orderList?.subOrder?.endDate
      ? PagesIndex.dayjs(orderList?.subOrder?.endDate)
      : null,
  };

  const initialValuesDocumentUpload = {
    name: "",
    image: "",
  };
  const initialValuesOrder = {
    scheduleDetails: selectedData?.slotAddData?.length
      ? selectedData?.slotAddData
      : [
          {
            type: selectedData?.type ? selectedData?.type : "dateRange",
            startDate: formRef?.current?.values?.startDate,
            endDate: formRef?.current?.values?.endDate,
            scheduleType: "program",
            creative: undefined,
            creativeDuration: 1,
            selectedDates: [],
            program: undefined,
            scheduleId: selectedData?.schedule,
            fromTime: null,
            toTime: null,
            slots: [],
            weekDays: weekArray?.length ? weekArray : [],
          },
        ],
  };
  const initialValuesOrderEdit = {
    scheduleDetails: selectedData?.slotAddData?.length
      ? selectedData?.slotAddData
      : [
          {
            type: selectedData?.type ? selectedData?.type : "dateRange",
            startDate: formRef?.current?.values?.startDate,
            endDate: formRef?.current?.values?.endDate,
            scheduleType: "program",
            creative: undefined,
            creativeDuration: 1,
            selectedDates: [],
            program: undefined,
            scheduleId: selectedData?.schedule,
            fromTime: null,
            toTime: null,
            slots: [],
            weekDays: weekArray?.length ? weekArray : [],
          },
        ],
  };
  const handleDownloadVideo = async (data) => {
    const a = document.createElement("a");
    if (data?.file?.name) {
      const file = URL.createObjectURL(data?.file);
      a.setAttribute("download", data?.file?.name); // Replace with the desired filename for the downloaded file
      a.href = file;
      a.click();
      window.URL.revokeObjectURL(file);
    } else {
      a.setAttribute("download", data?.documentsName); // Replace with the desired filename for the downloaded file
      a.href = process.env.REACT_APP_IMAGE_ENDPOINT + data?.file;
      a.click();
      window.URL.revokeObjectURL(
        process.env.REACT_APP_IMAGE_ENDPOINT + data?.file
      );
    }
  };
  const handleImageDelete = (indexId) => {
    const updatedData = docData.filter((item, index) => index !== indexId);
    setDocData(updatedData);
  };
  const handleAddDocument = (values) => {
    // Add new item
    let obj = {
      name: values?.name,
      file: values?.image,
    };
    setDocData((prev) => [...prev, obj]);
    handleCloseUploadDocument();
  };
  const handleAddData = (values) => {
    setButtonSpinner(true);
    const formData = new FormData();
    formData.append("orderId", id);
    formData.append("orderNo", orderList?.orderNo);
    formData.append("name", values?.name);
    formData.append(
      "startDate",
      PagesIndex.dayjs(values?.startDate).format("YYYY-MM-DD")
    );
    formData.append(
      "endDate",
      PagesIndex.dayjs(values?.endDate).format("YYYY-MM-DD")
    );
    formData.append("totalAmount", totalAmount);
    formData.append(
      "orderDetails",
      JSON.stringify(
        data.map((data) => {
          return { ...data };
        })
      )
    );
    docData?.forEach((data) => {
      formData.append(data?.name, data?.file);
    });

    PagesIndex.apiPostHandler(PagesIndex.Api.ADD_BOOKING, formData)
      .then((res) => {
        setButtonSpinner(false);
        if (res.status === 201 || res.status === 200) {
          navigate("/admin/sales-order-list");
          PagesIndex.toasterSuccess(res?.message);
        } else {
          PagesIndex.toasterError(res?.message);
        }
      })
      .catch((err) => {
        PagesIndex.toasterError(err.response.message);
      });
  };
  const handleOpenSave = () => {
    if (creativeAdded) {
      setOpenSave(true);
    } else {
      PagesIndex.toasterError(
        "No creative is added, Please add a creative to save this order"
      );
    }
  };
  const handleCloseSave = () => {
    setOpenSave(false);
  };
  const handleOpenDiscard = () => {
    setOpenDiscard(true);
  };
  const handleCloseDiscard = () => {
    setOpenDiscard(false);
  };
  const handleGetSalesOrder = () => {
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_BOOKING + "/" + id).then(
      (res) => {
        setLoading(false);
        if (res.status === 200) {
          setData([
            ...res?.data?.orderData?.orderDetails?.map((data) => {
              return {
                ...data,
                orgRemainingUnits: data?.orgRemainingUnits
                  ? data?.orgRemainingUnits
                  : data?.remainingUnits,
              };
            }),
          ]);
          setPrevBookingsData(res.data?.findSalesOrder);
        }
      }
    );
  };
  const [openScheduleView, setOpenScheduleView] = useState(false);
  const handleOpenScheduleView = (data, index) => {
    setOpenScheduleView(true);
    setSelectedData(data);
    setActiveIndex(index);
  };
  const handleCloseScheduleView = () => {
    setOpenScheduleView(false);
    setSelectedData({});
    setActiveIndex(0);
  };
  // add message modal
  const [openSchedule, setOpenSchedule] = useState(false);
  const handleOpenSchedule = (data, index) => {
    setOpenSchedule(true);
    setSelectedData(data);
    setActiveIndex(index);
  };
  const handleCloseSchedule = () => {
    setOpenSchedule(false);
    setSelectedData({});
    setActiveIndex(0);
  };
  const [openScheduleEdit, setOpenScheduleEdit] = useState(false);
  const handleOpenScheduleEdit = (data, index, id) => {
    console.log(data, "data313");
    setEditData(data);
    setEditId(id);
    setOpenScheduleEdit(true);
    setSelectedData(data);
    setActiveIndex(index);
  };
  const handleCloseScheduleEdit = () => {
    setEditData({});
    setEditId("");
    setOpenScheduleEdit(false);
    setSelectedData({});
    setActiveIndex(0);
  };
  const handleAddModalData = (values) => {
    const weekData = values?.scheduleDetails.map((data) =>
      data?.type === "dateRange"
        ? data?.weekDays?.reduce((acc, curr) => acc + curr?.total, 0) *
          data?.creativeDuration
        : data?.selectedDates?.reduce(
            (acc, curr) => acc + parseInt(curr?.value),
            0
          ) * data?.creativeDuration
    );
    const counts = weekData?.reduce((acc, curr) => acc + curr, 0);
    if (counts > selectedData?.orgRemainingUnits) {
      PagesIndex.toasterError(
        "Value of units exceeds amount of remaining units."
      );
    } else {
      setData((prev) => {
        const data = [...prev];
        data[activeIndex].remainingUnits =
          data[activeIndex]?.orgRemainingUnits - counts;
        data[activeIndex].orgRemainingUnits =
          data[activeIndex]?.orgRemainingUnits - counts;
        data[activeIndex].units = counts;
        data[activeIndex].slotAddData = values?.scheduleDetails;
        data[activeIndex].priority = selectedData?.priority;
        return data;
      });
      setCreativeAdded(true);
      handleCloseSchedule();
    }
  };
  const handleAddModalDataEdit = (values) => {
    const weekData = values?.scheduleDetails.map((data) =>
      data?.type === "dateRange"
        ? data?.weekDays?.reduce((acc, curr) => acc + curr?.total, 0) *
          data?.creativeDuration
        : data?.selectedDates?.reduce(
            (acc, curr) => acc + parseInt(curr?.value),
            0
          ) * data?.creativeDuration
    );
    const counts = weekData?.reduce((acc, curr) => acc + curr, 0);
    if (counts > selectedData?.orgRemainingUnits + selectedData?.units) {
      PagesIndex.toasterError(
        "Value of units exceeds amount of remaining units."
      );
    } else {
      const data = { ...editData };
      data.remainingUnits =
        selectedData?.orgRemainingUnits + selectedData?.units - counts;
      data.orgRemainingUnits =
        selectedData?.orgRemainingUnits + selectedData?.units - counts;
      data.units = counts;
      data.slotAddData = values?.scheduleDetails;
      data.priority = selectedData?.priority;
      setButtonSpinner(true);
      const formData = new URLSearchParams();
      formData.append("subSalesOrderId", editId);
      formData.append("orderId", data?._id);
      formData.append("orderDetails", JSON.stringify(data));
      PagesIndex.apiPostHandler(PagesIndex.Api.EDIT_BOOKING, formData)
        .then((res) => {
          setButtonSpinner(false);
          if (res.status === 201 || res.status === 200) {
            handleGetSalesOrder();
            handleCloseScheduleEdit();
            PagesIndex.toasterSuccess(res?.message);
          } else {
            PagesIndex.toasterError(res?.message);
          }
        })
        .catch((err) => {
          PagesIndex.toasterError(err.response.message);
        });
    }
  };
  const setWeekDays = (selectedStartDate, selectedEndDate) => {
    var date = PagesIndex.moment(new Date(selectedStartDate));
    var start = PagesIndex.moment(date).startOf("week");
    var endDate = PagesIndex.moment(new Date(selectedEndDate));
    var end = PagesIndex.moment(endDate).endOf("week");
    var weekArray = [];
    while (start <= end) {
      let week = {
        dates: [],
        name: `Week ${weekArray.length + 1}`,
        total: 0,
      };

      for (let k = 0; k < 7; k++) {
        week.dates.push({
          fullDate: start.format("DD-MM-YYYY"),
          date: start.format("DD MMM"),
          value: 0,
          disabled: !start.isBetween(date, endDate, null, "[]"),
        });
        start.add(1, "days");
      }
      weekArray.push(week);
    }
    if (selectedStartDate && selectedEndDate) {
      setWeekArray(weekArray);
    } else {
      setWeekArray([]);
    }
  };
  const exportData = (data, fileName, type) => {
    // Create a link and download the file
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
  const generateCSV = () => {
    const dataArray = prevBookingsData.flatMap((order) =>
      order.orderDetails.map((orderDetail) => ({
        ...order, // Spread order data
        ...orderDetail, // Spread orderDetail data
        orderDetails: undefined, // Remove nested orderDetails
      }))
    );
    let headers = [];
    headers = [
      "Booking Name",
      "Sub Order No",
      "Start Date",
      "End Date",
      "Platform",
      "Element",
      "Total",
      "Selling Rate",
      "Unit",
      "Used Units",
    ];
    let modifiedData = dataArray.map((data) => {
      let objData = [];
      objData = [
        data?.name ? data?.name?.replaceAll(",", " ") : "-",
        data?.subOrderNo ? data?.subOrderNo?.replaceAll(",", " ") : "-",
        data?.startDate
          ? PagesIndex.moment(data?.startDate).format("DD/MM/YYYY")
          : "-",
        data?.endDate
          ? PagesIndex.moment(data?.endDate).format("DD/MM/YYYY")
          : "-",
        data?.platform ? data?.platform?.replaceAll(",", " ") : "-",
        data?.elements ? data?.elements?.replaceAll(",", " ") : "-",
        data?.totalSeconds ? data?.totalSeconds : "-",
        data?.discountrate ? data?.discountrate : "0",
        data?.unit ? data?.unit : "-",
        data?.units ? data?.units : "0",
      ];

      return objData.join(",");
    });

    exportData(
      [[headers, ...modifiedData].join("\n")],
      `${PagesIndex.moment().format("DD-MM-YYYY")}_Sales_sub_order_list.csv`,
      "text/csv"
    );
  };
  const handleOpenLogModal = (id) => {
    setOpenLogModal(true);
    setActivityLoading(true);
    PagesIndex.apiGetHandler(
      PagesIndex.Api.BOOKING_ACTIVITY_LOG + "/" + id
    ).then((res) => {
      setActivityLoading(false);
      if (res.status === 200) {
        setActivityLog(res.data);
      }
    });
  };
  const handleCloseLogModal = () => {
    setOpenLogModal(false);
    setActivityLog([]);
  };
  const renderActivityTableRows = () => {
    return activityLog.reverse().map((data) => {
      return (
        <Index.TableRow
          sx={{
            "&:last-child td, &:last-child th": {
              border: 0,
            },
          }}
          key={data?._id}
        >
          <Index.TableCell
            component="td"
            variant="td"
            scope="row"
            className="table-td"
          >
            <Index.Typography className="admin-table-data-text">
              <Index.Tooltip
                title={data?.actionType}
                arrow
                placement="top"
                className="admin-tooltip"
              >
                {data?.actionType}
              </Index.Tooltip>
            </Index.Typography>
          </Index.TableCell>

          <Index.TableCell component="td" variant="td" className="table-td">
            {data?.actionBy?.name}-
            {PagesIndex.moment(data?.updatedAt).format("DD/MM/YYYY hh:mm:ss")}
          </Index.TableCell>
        </Index.TableRow>
      );
    });
  };
  const renderActivityLogContent = () => {
    return (
      <>
        {!activityLoading &&
          activityLog?.length > 0 &&
          renderActivityTableRows()}
        {!activityLoading && activityLog.length === 0 && (
          <PagesIndex.DataNotFound />
        )}
      </>
    );
  };
  return (
    <Index.Box className="admin-dashboard-content admin-user-management-content">
      <Index.Box className="admin-user-list-flex admin-page-title-main">
        <Index.Typography
          className="admin-page-title admin-user-list-page-title"
          component="h2"
          variant="h2"
        >
          Add Booking
        </Index.Typography>
      </Index.Box>

      <>
        <PagesIndex.Formik
          enableReinitialize
          onSubmit={handleOpenSave}
          initialValues={clientInitialValues}
          validationSchema={PagesIndex.salesSubOrder}
          innerRef={formRef}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
          }) => (
            <form onSubmit={handleSubmit} noValidate="novalidate">
              <Index.Box className="common-card add-sales-card">
                <Index.Box
                  display="grid"
                  gridTemplateColumns="repeat(12, 1fr)"
                  gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                >
                  <Index.Box
                    gridColumn={{
                      xs: "span 12",
                      sm: "span 3",
                      md: "span 3",
                      lg: "span 3",
                    }}
                    className="grid-column"
                  >
                    <Index.Box className="admin-input-box admin-add-event-input-box">
                      <Index.FormHelperText className="admin-form-lable">
                        Booking Name
                        <span className="astrick-sing">*</span>
                      </Index.FormHelperText>
                      <Index.Box className="admin-form-group">
                        <Index.TextField
                          name="name"
                          fullWidth
                          id="name"
                          className="admin-form-control"
                          placeholder="Enter Booking Name"
                          onChange={handleChange}
                          value={values?.name}
                          inputProps={{ maxLength: 50 }}
                        />
                      </Index.Box>
                      {errors.name && touched.name && (
                        <PagesIndex.FormHelperText className="admin-error-text">
                          {errors.name}
                        </PagesIndex.FormHelperText>
                      )}
                    </Index.Box>
                  </Index.Box>

                  <Index.Box
                    gridColumn={{
                      xs: "span 12",
                      sm: "span 3",
                      md: "span 3",
                      lg: "span 3",
                    }}
                    className="grid-column"
                  >
                    <Index.Box className="admin-input-box admin-date-input-main ">
                      <Index.FormHelperText className="admin-form-lable">
                        <span>Start Date</span>
                        <span className="astrick-sing">*</span>
                      </Index.FormHelperText>
                      <Index.Box className="admin-form-group">
                        <PagesIndex.LocalizationProvider
                          dateAdapter={Index.AdapterDayjs}
                        >
                          <PagesIndex.DatePicker
                            open={openCalenderStart}
                            onClose={() => setOpenCalenderStart(false)}
                            className="admin-form-control admin-date-picker-control"
                            value={values.startDate} // Use '01/01/2000' as the default value
                            onChange={(date) => {
                              setFieldTouched("startDate", false);
                              setFieldValue("startDate", date);
                              setFieldValue("endDate", null);
                              setFieldValue("selectedDates", []);
                              setWeekDays(date, values?.endDate);
                            }}
                            minDate={
                              adminDetails?._id === "65f1a3fdc63b34cc5e6f660e"
                                ? PagesIndex.dayjs("1900-01-01")
                                : PagesIndex.dayjs(orderList?.startDate)
                            }
                            maxDate={PagesIndex.dayjs(orderList?.endDate)}
                            slotProps={{
                              popper: {
                                className: "date-picker-body",
                              },
                              textField: {
                                readOnly: true,
                                onClick: () => setOpenCalenderStart(true),
                              },
                              inputAdornment: {
                                onClick: () => setOpenCalenderStart(true), // This triggers on the calendar icon
                              },
                            }}
                            format="DD/MM/YYYY"
                          />
                        </PagesIndex.LocalizationProvider>
                        <Index.FormHelperText className="admin-error-text">
                          {errors.startDate &&
                            touched.startDate &&
                            errors.startDate}
                        </Index.FormHelperText>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>

                  <Index.Box
                    gridColumn={{
                      xs: "span 12",
                      sm: "span 3",
                      md: "span 3",
                      lg: "span 3",
                    }}
                    className="grid-column"
                  >
                    <Index.Box className="admin-input-box admin-date-input-main ">
                      <Index.FormHelperText className="admin-form-lable">
                        <span>End Date</span>
                        <span className="astrick-sing">*</span>
                      </Index.FormHelperText>
                      <Index.Box className="admin-form-group">
                        <PagesIndex.LocalizationProvider
                          dateAdapter={Index.AdapterDayjs}
                        >
                          <PagesIndex.DatePicker
                            open={openCalenderEnd}
                            onClose={() => setOpenCalenderEnd(false)}
                            className="admin-form-control admin-date-picker-control"
                            value={values.endDate} // Use '01/01/2000' as the default value
                            onChange={(date) => {
                              setFieldValue("endDate", date);
                              setWeekDays(values?.startDate, date);
                            }}
                            minDate={
                              values.startDate
                                ? PagesIndex.dayjs(values.startDate).add(
                                    0,
                                    "day"
                                  )
                                : adminDetails?._id ===
                                  "65f1a3fdc63b34cc5e6f660e"
                                ? PagesIndex.dayjs("1900-01-01")
                                : PagesIndex.dayjs().add(0, "day")
                            }
                            maxDate={PagesIndex.dayjs(orderList?.endDate)}
                            slotProps={{
                              popper: {
                                className: "date-picker-body",
                              },
                              textField: {
                                readOnly: true,
                                onClick: () => setOpenCalenderEnd(true),
                              },
                              inputAdornment: {
                                onClick: () => setOpenCalenderEnd(true), // This triggers on the calendar icon
                              },
                            }}
                            format="DD/MM/YYYY"
                          />
                        </PagesIndex.LocalizationProvider>
                        <Index.FormHelperText className="admin-error-text">
                          {errors.endDate && touched.endDate && errors.endDate}
                        </Index.FormHelperText>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
                <Index.Box className="other-flex">
                  <Index.Box className="admin-sub-title-main">
                    <Index.Typography
                      className="admin-sub-title"
                      component="h2"
                      variant="h2"
                    >
                      Order Details
                    </Index.Typography>
                  </Index.Box>
                </Index.Box>

                <Index.Box className="common-card">
                  <Index.Box
                    className={`admin-client-table-main page-table-main`}
                  >
                    <Index.TableContainer
                      component={Index.Paper}
                      className="table-container"
                    >
                      {loading ? (
                        <PagesIndex.Loader />
                      ) : (
                        <Index.Table
                          aria-label="simple table"
                          className="table"
                        >
                          <Index.TableHead className="table-head">
                            <Index.TableRow className="table-row">
                              <Index.TableCell
                                component="th"
                                variant="th"
                                className="table-th"
                                width="2%"
                              >
                                Sr. No.
                              </Index.TableCell>

                              <Index.TableCell
                                component="th"
                                variant="th"
                                className="table-th"
                                width="5%"
                              >
                                Platform
                              </Index.TableCell>

                              <Index.TableCell
                                component="th"
                                variant="th"
                                className="table-th"
                                width="5%"
                              >
                                Element
                              </Index.TableCell>

                              <Index.TableCell
                                component="th"
                                variant="th"
                                className="table-th"
                                width="5%"
                              >
                                Total
                              </Index.TableCell>

                              <Index.TableCell
                                component="th"
                                variant="th"
                                className="table-th"
                                width="5%"
                              >
                                Selling Rate
                              </Index.TableCell>

                              <Index.TableCell
                                component="th"
                                variant="th"
                                className="table-th"
                                width="5%"
                              >
                                Remaining Units
                              </Index.TableCell>

                              {/* <Index.TableCell
                                component="th"
                                variant="th"
                                className="table-th"
                                width="5%"
                              >
                                Amount
                              </Index.TableCell> */}

                              <Index.TableCell
                                component="th"
                                variant="th"
                                className="table-th"
                                width="5%"
                              >
                                Schedule
                              </Index.TableCell>
                            </Index.TableRow>
                          </Index.TableHead>
                          <Index.TableBody className="table-body">
                            {loading ? (
                              <PagesIndex.Loader />
                            ) : (
                              <TableData
                                data={[...data]}
                                currentPage={1}
                                setData={setData}
                                totalAmount={totalAmount}
                                handleOpenSchedule={handleOpenSchedule}
                                handleOpenScheduleView={handleOpenScheduleView}
                                formRef={formRef}
                              />
                            )}

                            {/* <Index.TableRow>
                              <Index.TableCell
                                component="td"
                                variant="td"
                                className="table-td"
                              ></Index.TableCell>
                              <Index.TableCell
                                component="td"
                                variant="td"
                                className="table-td"
                              ></Index.TableCell>
                              <Index.TableCell
                                component="td"
                                variant="td"
                                className="table-td"
                              ></Index.TableCell>
                              <Index.TableCell
                                component="td"
                                variant="td"
                                className="table-td"
                              >
                                <Index.Box className="total-text">
                                  {data?.reduce(
                                    (acc, curr) =>
                                      acc + parseFloat(curr.totalSeconds),
                                    0
                                  )}
                                </Index.Box>
                              </Index.TableCell>
                              <Index.TableCell
                                component="td"
                                variant="td"
                                className="table-td"
                                align="right"
                              >
                                <Index.Box className="total-text">
                                  Total Ramainig Units:
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell
                                component="td"
                                variant="td"
                                className="table-td"
                              >
                                <Index.Box className="total-text">
                                  {data?.reduce(
                                    (acc, curr) =>
                                      acc + parseFloat(curr.remainingUnits),
                                    0
                                  )}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell
                                component="td"
                                variant="td"
                                className="table-td"
                              ></Index.TableCell>
                            </Index.TableRow> */}
                          </Index.TableBody>
                        </Index.Table>
                      )}
                    </Index.TableContainer>
                  </Index.Box>

                  <Index.Box className="upload-document-row">
                    {adminDetails?.roleId?.permissions?.includes(
                      "sales_order_add"
                    ) && (
                      <>
                        <Index.Box className="admin-userlist-inner-btn-flex upload-document-btn-end">
                          <Index.Box className="admin-sub-title-main">
                            <Index.Typography
                              className="admin-sub-title"
                              component="h2"
                              variant="h2"
                            >
                              List of Attachment
                            </Index.Typography>
                          </Index.Box>
                          <Index.Box className="admin-adduser-btn-main btn-main-primary document-upload-btn-main">
                            <Index.Button
                              className="admin-adduser-btn document-upload-btn"
                              onClick={() => {
                                handleOpenUploadDocument();
                              }}
                            >
                              <img
                                src={PagesIndex.Svg.darkplus}
                                className="admin-plus-icon"
                                alt="plus"
                              />
                              <span>Upload Documents</span>
                            </Index.Button>
                          </Index.Box>
                        </Index.Box>
                        {docData?.map((url, index) => {
                          return (
                            <Index.Box
                              className="document-data-flex"
                              key={url?.file?.name}
                            >
                              <Index.Box className="document-content-main">
                                <Index.Box className="document-lable-flex">
                                  <Index.Typography className="document-id-text">
                                    {url?.name}
                                  </Index.Typography>
                                  <Index.Typography className="document-lable-text">
                                    {url?.file?.name}
                                  </Index.Typography>
                                </Index.Box>
                              </Index.Box>
                              <Index.Box className="document-content-main">
                                <Index.Box className="document-delete-main">
                                  <Index.Button
                                    className="admin-table-data-btn"
                                    onClick={() => handleDownloadVideo(url)}
                                  >
                                    <img
                                      src={PagesIndex.Svg.download}
                                      className="admin-icon"
                                      alt="Download"
                                    ></img>
                                  </Index.Button>
                                  <Index.Button
                                    className="document-delete-btn"
                                    onClick={() => handleImageDelete(index)}
                                  >
                                    <img
                                      src={PagesIndex.Svg.trash}
                                      className="admin-icon"
                                      alt="Delete"
                                    ></img>
                                  </Index.Button>
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          );
                        })}
                      </>
                    )}
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <Index.Box className="admin-user-btn-flex">
                <Index.Box className="border-btn-main">
                  <Index.Button
                    className="border-btn"
                    onClick={handleOpenDiscard}
                    disabled={buttonSpinner}
                  >
                    Discard
                  </Index.Button>
                </Index.Box>
                <Index.Box className="btn-main-primary">
                  <Index.Button
                    className="btn-primary"
                    type="submit"
                    disabled={buttonSpinner}
                  >
                    {buttonSpinner ? (
                      <PagesIndex.Spinner />
                    ) : (
                      <>
                        <img
                          src={PagesIndex.Svg.save}
                          className="admin-user-save-icon"
                          alt="Submit"
                        />
                        <span>Add</span>
                      </>
                    )}
                  </Index.Button>
                </Index.Box>
              </Index.Box>
              {prevBookingsData?.length ? (
                <>
                  <Index.Box className="other-flex card-devider">
                    <Index.Box className="admin-sub-title-main">
                      <Index.Typography
                        className="admin-sub-title"
                        component="h2"
                        variant="h2"
                      >
                        Previous Booking Details
                      </Index.Typography>
                    </Index.Box>
                    <Index.Box className="admin-adduser-btn-main btn-main-secondary">
                      <Index.Button
                        className="admin-adduser-btn btn-secondary"
                        onClick={generateCSV}
                      >
                        <img
                          src={PagesIndex.Svg.exporticon}
                          className="admin-plus-icon"
                          alt="plus"
                        />
                        <span>Export CSV</span>
                      </Index.Button>
                    </Index.Box>
                  </Index.Box>

                  <Index.Box className="common-card">
                    <Index.Box
                      className={`admin-client-table-main page-table-main`}
                    >
                      <Index.TableContainer
                        component={Index.Paper}
                        className="table-container"
                      >
                        {loading ? (
                          <PagesIndex.Loader />
                        ) : (
                          prevBookingsData?.map((dataOuter, index) => {
                            return (
                              <Index.Box className="name-highlight-box-flex-wrapper">
                                <Index.Box className="name-highlight-box-flex">
                                  <Index.Box className="name-highlight-box">
                                    <Index.Typography className="name-highlight-text">
                                      {dataOuter?.name} -{" "}
                                      <span className="name-highlight-id-text">
                                        {dataOuter?.subOrderNo}
                                      </span>
                                    </Index.Typography>
                                  </Index.Box>
                                  <Index.Box className="date-box-flex">
                                    <Index.Typography className="date-text">
                                      Start Date:
                                      <span className="date-text-span">
                                        {PagesIndex.moment(
                                          dataOuter?.startDate
                                        ).format("DD/MM/YYYY")}
                                      </span>
                                    </Index.Typography>
                                    <Index.Typography className="date-text">
                                      End Date:
                                      <span className="date-text-span">
                                        {PagesIndex.moment(
                                          dataOuter?.endDate
                                        ).format("DD/MM/YYYY")}
                                      </span>
                                    </Index.Typography>
                                    <Index.Typography className="date-text">
                                      Created Date & Time:
                                      <span className="date-text-span">
                                        {PagesIndex.moment(
                                          dataOuter?.createdAt
                                        ).format("DD/MM/YYYY hh:mm:ss A")}
                                      </span>
                                    </Index.Typography>
                                    {adminDetails?.roleId?.permissions?.includes(
                                      "sales_order_log"
                                    ) && (
                                      <Index.Box className="admin-adduser-btn-main btn-main-primary">
                                        <Index.Button
                                          className="admin-adduser-btn btn-primary"
                                          onClick={() =>
                                            handleOpenLogModal(dataOuter?._id)
                                          }
                                        >
                                          {/* <img
                                            src={PagesIndex.Svg.exporticon}
                                            className="admin-plus-icon"
                                            alt="plus"
                                          /> */}
                                          <span>Logs</span>
                                        </Index.Button>
                                      </Index.Box>
                                    )}
                                  </Index.Box>
                                </Index.Box>
                                <Index.Table
                                  aria-label="simple table"
                                  className="table"
                                  key={data?._id}
                                >
                                  <Index.TableHead className="table-head">
                                    <Index.TableRow className="table-row">
                                      <Index.TableCell
                                        component="th"
                                        variant="th"
                                        className="table-th"
                                        width="2%"
                                      >
                                        Sr. No.
                                      </Index.TableCell>
                                      <Index.TableCell
                                        component="th"
                                        variant="th"
                                        className="table-th"
                                        width="2%"
                                      >
                                        Id
                                      </Index.TableCell>

                                      <Index.TableCell
                                        component="th"
                                        variant="th"
                                        className="table-th"
                                        width="5%"
                                      >
                                        Platform
                                      </Index.TableCell>

                                      <Index.TableCell
                                        component="th"
                                        variant="th"
                                        className="table-th"
                                        width="5%"
                                      >
                                        Element
                                      </Index.TableCell>

                                      <Index.TableCell
                                        component="th"
                                        variant="th"
                                        className="table-th"
                                        width="5%"
                                      >
                                        Total
                                      </Index.TableCell>

                                      <Index.TableCell
                                        component="th"
                                        variant="th"
                                        className="table-th"
                                        width="5%"
                                      >
                                        Selling Rate
                                      </Index.TableCell>

                                      {/* <Index.TableCell
                                        component="th"
                                        variant="th"
                                        className="table-th"
                                        width="5%"
                                      >
                                        Remaining Units
                                      </Index.TableCell> */}

                                      <Index.TableCell
                                        component="th"
                                        variant="th"
                                        className="table-th"
                                        width="5%"
                                      >
                                        Used Units
                                      </Index.TableCell>

                                      <Index.TableCell
                                        component="th"
                                        variant="th"
                                        className="table-th"
                                        width="5%"
                                      >
                                        Action
                                      </Index.TableCell>
                                    </Index.TableRow>
                                  </Index.TableHead>
                                  <Index.TableBody className="table-body">
                                    {dataOuter?.orderDetails?.map(
                                      (data, index) => {
                                        return (
                                          <Index.TableRow
                                            sx={{
                                              "&:last-child td, &:last-child th":
                                                {
                                                  border: 0,
                                                },
                                            }}
                                            key={data?._id}
                                          >
                                            <Index.TableCell
                                              component="td"
                                              variant="td"
                                              className="table-td"
                                            >
                                              <Index.Typography className="admin-table-data-text">
                                                {index + 1}
                                              </Index.Typography>
                                            </Index.TableCell>
                                            <Index.TableCell
                                              component="td"
                                              variant="td"
                                              className="table-td"
                                            >
                                              <Index.Typography className="admin-table-data-text">
                                                {data?._id}
                                              </Index.Typography>
                                            </Index.TableCell>

                                            <Index.TableCell
                                              component="td"
                                              variant="td"
                                              className="table-td"
                                            >
                                              <Index.Typography className="admin-table-data-text">
                                                {data?.platform
                                                  ? data?.platform
                                                  : "-"}
                                              </Index.Typography>
                                            </Index.TableCell>

                                            <Index.TableCell
                                              component="td"
                                              variant="td"
                                              className="table-td"
                                            >
                                              <Index.Typography className="admin-table-data-text">
                                                {data?.elements
                                                  ? data?.elements
                                                  : "-"}
                                              </Index.Typography>
                                            </Index.TableCell>

                                            <Index.TableCell
                                              component="td"
                                              variant="td"
                                              className="table-td"
                                            >
                                              <Index.Typography className="admin-table-data-text">
                                                {data?.totalSeconds
                                                  ? data?.totalSeconds
                                                  : 0}{" "}
                                                ({data?.unit})
                                              </Index.Typography>
                                            </Index.TableCell>

                                            <Index.TableCell
                                              component="td"
                                              variant="td"
                                              className="table-td"
                                            >
                                              <Index.Typography className="admin-table-data-text">
                                                {" "}
                                                {data?.discountrate
                                                  ? data?.discountrate
                                                  : 0}
                                              </Index.Typography>
                                            </Index.TableCell>

                                            {/* <Index.TableCell
                                              component="td"
                                              variant="td"
                                              className="table-td"
                                            >
                                              <Index.Typography className="admin-table-data-text">
                                                {" "}
                                                {parseFloat(
                                                  data?.remainingUnits || 0
                                                )}
                                              </Index.Typography>
                                            </Index.TableCell> */}
                                            <Index.TableCell
                                              component="td"
                                              variant="td"
                                              className="table-td"
                                            >
                                              <Index.Typography className="admin-table-data-text">
                                                {" "}
                                                {parseFloat(data?.units || 0)}
                                              </Index.Typography>
                                            </Index.TableCell>
                                            <Index.TableCell
                                              component="td"
                                              variant="td"
                                              scope="row"
                                              className="table-td"
                                            >
                                              <Index.Box className="input-cus-flex">
                                                {data?.platform === "TV FCT" ||
                                                data?.platform ===
                                                  "TV Non FCT" ? (
                                                  <>
                                                    <Index.Tooltip
                                                      title={"Schedule"}
                                                      arrow
                                                      placement="top"
                                                      className="admin-tooltip"
                                                    >
                                                      <Index.Button
                                                        className="schedule-btn view-schedule-btn border-btn"
                                                        // disabled={!data?.units}
                                                        onClick={() => {
                                                          handleOpenScheduleEdit(
                                                            data,
                                                            index,
                                                            dataOuter?._id
                                                          );
                                                        }}
                                                      >
                                                        <img
                                                          src={
                                                            PagesIndex.Svg
                                                              .calendaricon
                                                          }
                                                          className="admin-icons"
                                                          alt="discard"
                                                        />
                                                      </Index.Button>
                                                    </Index.Tooltip>
                                                    <Index.Tooltip
                                                      title={"View"}
                                                      arrow
                                                      placement="top"
                                                      className="admin-tooltip"
                                                    >
                                                      <Index.Button
                                                        className="schedule-btn view-schedule-btn border-btn"
                                                        // disabled={!data?.units}
                                                        onClick={() => {
                                                          handleOpenScheduleView(
                                                            data,
                                                            index
                                                          );
                                                        }}
                                                      >
                                                        <img
                                                          src={
                                                            PagesIndex.Svg
                                                              .yelloweye
                                                          }
                                                          className="admin-icons"
                                                          alt="discard"
                                                        />
                                                      </Index.Button>
                                                    </Index.Tooltip>
                                                  </>
                                                ) : (
                                                  "-"
                                                )}
                                              </Index.Box>
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        );
                                      }
                                    )}
                                  </Index.TableBody>
                                </Index.Table>

                                {dataOuter?.document?.length ? (
                                  <Index.Box>
                                    {dataOuter?.document?.map((data) => {
                                      return (
                                        <Index.Box className="document-lable-flex doucument-show-flex">
                                          <Index.Box className="document-download-main">
                                            <Index.Button className="document-download-btn">
                                              <img
                                                src={PagesIndex.Svg.download}
                                                className="admin-icon"
                                                alt="Download"
                                              ></img>
                                            </Index.Button>
                                          </Index.Box>
                                          <Index.Typography className="document-id-text">
                                            {data?.name}
                                          </Index.Typography>
                                          <Index.Typography className="document-lable-text">
                                            {data?.file}
                                          </Index.Typography>
                                        </Index.Box>
                                      );
                                    })}
                                  </Index.Box>
                                ) : (
                                  ""
                                )}
                              </Index.Box>
                            );
                          })
                        )}
                      </Index.TableContainer>
                    </Index.Box>
                  </Index.Box>
                </>
              ) : (
                ""
              )}
            </form>
          )}
        </PagesIndex.Formik>

        <Index.Modal
          open={openUploadDocument}
          onClose={handleCloseUploadDocument}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="admin-modal"
        >
          <PagesIndex.Formik
            enableReinitialize
            onSubmit={handleAddDocument}
            initialValues={initialValuesDocumentUpload}
            validationSchema={PagesIndex.uploadSalesDocumentSchema}
            innerRef={formRef}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit} noValidate="novalidate">
                <Index.Box
                  sx={style}
                  className="admin-add-user-modal-inner-main admin-modal-inner"
                >
                  <Index.Box className="admin-modal-header">
                    <Index.Typography
                      id="modal-modal-title"
                      className="admin-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      Upload Document
                    </Index.Typography>
                  </Index.Box>
                  <Index.Box
                    className="admin-modal-hgt-scroll cus-scrollbar"
                    id="scrollDiv"
                  >
                    {/* <ScrollIntoView /> */}

                    <Index.Box className="admin-input-box admin-modal-input-box">
                      <Index.FormHelperText className="admin-form-lable">
                        Document Type<span className="astrick-sing">*</span>
                      </Index.FormHelperText>
                      <Index.Box className="admin-form-group">
                        <Index.Box className="admin-dropdown-box">
                          <Index.FormControl className="admin-form-control">
                            <Index.Select
                              name="name"
                              className="admin-dropdown-select "
                              value={values?.name}
                              onChange={handleChange}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                              renderValue={
                                values?.name
                                  ? undefined
                                  : () => "Select Document Type"
                              }
                            >
                              <Index.MenuItem
                                value="ro"
                                className="admin-menuitem"
                              >
                                RO
                              </Index.MenuItem>
                              <Index.MenuItem
                                value="to"
                                className="admin-menuitem"
                              >
                                TO
                              </Index.MenuItem>
                              <Index.MenuItem
                                value="others"
                                className="admin-menuitem"
                              >
                                Other
                              </Index.MenuItem>
                            </Index.Select>
                          </Index.FormControl>
                          {touched.name && errors.name && (
                            <PagesIndex.FormHelperText className="admin-error-text">
                              {errors.name}
                            </PagesIndex.FormHelperText>
                          )}
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box className="admin-input-box admin-modal-input-box">
                      <Index.FormHelperText className="admin-form-lable">
                        Document<span className="astrick-sing">*</span>
                      </Index.FormHelperText>
                      {values?.image ? (
                        <Index.Box className="file-upload-main thumbnail-box admin-file-browse-btn-main ">
                          <Index.Box className="upload-news-img-box">
                            {renderImage(values)}
                          </Index.Box>
                          <Index.Button
                            variant="contained"
                            component="label"
                            className="admin-file-browse-btn"
                          >
                            <img
                              src={PagesIndex.Svg.whiteedit}
                              className="admin-browse-icon-img"
                              alt="upload img"
                            ></img>
                            <input
                              hidden
                              accept="image/*, .pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                              id="image"
                              name="image"
                              type="file"
                              onChange={(e) => {
                                if (e.target.files?.length !== 0) {
                                  setFieldValue("image", e.target.files[0]);
                                }
                              }}
                            />
                          </Index.Button>
                        </Index.Box>
                      ) : (
                        <Index.Box className="file-upload-main thumbnail-box">
                          <Index.Button
                            variant="contained"
                            component="label"
                            className="file-upload-button"
                          >
                            {renderImage(values)}
                            <input
                              hidden
                              accept="image/*, .pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                              id="image"
                              name="image"
                              type="file"
                              onChange={(e) => {
                                if (e.target.files?.length !== 0) {
                                  setFieldValue("image", e.target.files[0]);
                                }
                              }}
                            />
                          </Index.Button>
                        </Index.Box>
                      )}
                      {touched.image && errors.image && (
                        <PagesIndex.FormHelperText className="admin-error-text">
                          {errors.image}
                        </PagesIndex.FormHelperText>
                      )}
                    </Index.Box>
                  </Index.Box>
                  <Index.Box className="modal-footer">
                    <Index.Box className="admin-modal-user-btn-flex">
                      <Index.Box className="admin-discard-btn-main border-btn-main">
                        <Index.Button
                          className="admin-discard-user-btn border-btn"
                          onClick={handleCloseUploadDocument}
                        >
                          Discard
                        </Index.Button>
                      </Index.Box>
                      <Index.Box className="admin-save-btn-main btn-main-primary">
                        <Index.Button
                          className="admin-save-user-btn btn-primary"
                          type="submit"
                        >
                          <img
                            src={PagesIndex.Svg.save}
                            className="admin-user-save-icon"
                            alt="Upload"
                          />
                          <span>Upload</span>
                        </Index.Button>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </form>
            )}
          </PagesIndex.Formik>
        </Index.Modal>
        <Index.Modal
          open={openSchedule}
          onClose={handleCloseSchedule}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="admin-modal"
        >
          <PagesIndex.Formik
            enableReinitialize
            onSubmit={handleAddModalData}
            initialValues={initialValuesOrder}
            validationSchema={PagesIndex.salesSubOrderModal}
            innerRef={formRefOrder}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              setFieldValue,
            }) => {
              const weekData = values?.scheduleDetails.map((data) =>
                data?.type === "dateRange"
                  ? data?.weekDays?.reduce(
                      (acc, curr) => acc + curr?.total,
                      0
                    ) * data?.creativeDuration
                  : data?.selectedDates?.reduce(
                      (acc, curr) => acc + parseInt(curr?.value),
                      0
                    ) * data?.creativeDuration
              );
              const counts = weekData?.reduce(
                (acc, curr) => acc + (curr || 0),
                0
              );
              const selectedCreativeIds = values?.scheduleDetails?.map((row) => row?.creative);
              return (
                <form onSubmit={handleSubmit} noValidate="novalidate">
                  <Index.Box
                    sx={style}
                    className="admin-add-user-modal-inner-main admin-modal-inner order-details-modal-inner"
                  >
                    <Index.Box className="admin-modal-header">
                      <Index.Typography
                        id="modal-modal-title"
                        className="admin-modal-title"
                        variant="h6"
                        component="h2"
                      >
                        {" "}
                        View Order Details
                      </Index.Typography>
                      <Index.Button
                        className="modal-close-btn"
                        onClick={handleCloseSchedule}
                      >
                        <img
                          src={PagesIndex.Svg.closeblack}
                          className="admin-modal-close-icon"
                          alt="Close"
                        />
                      </Index.Button>
                    </Index.Box>
                    <Index.Box className="grid-row view-order-row">
                      <Index.Box
                        display="grid"
                        gridTemplateColumns="repeat(12, 1fr)"
                        gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                      >
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="order-inner-box">
                            <Index.Typography className="order-inner-lable-text">
                              Platform Name:{" "}
                            </Index.Typography>
                            <Index.Typography className="order-inner-value-text">
                              {selectedData?.platform}
                            </Index.Typography>
                          </Index.Box>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 8",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="order-inner-box">
                            <Index.Typography className="order-inner-lable-text">
                              Element:{" "}
                            </Index.Typography>
                            <Index.Typography className="order-inner-value-text">
                              {selectedData?.elements}
                            </Index.Typography>
                          </Index.Box>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 8",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="order-inner-box">
                            <Index.Typography className="order-inner-lable-text">
                              Total Remaining Units:{" "}
                            </Index.Typography>
                            <Index.Typography className="order-inner-value-text">
                              {selectedData?.orgRemainingUnits - counts}
                            </Index.Typography>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
                      <Index.Box className="order-show-box">
                        <FieldArray name="scheduleDetails">
                          {({ push, remove }) =>
                            values?.scheduleDetails?.map((data, index) => {
                              const slots = `scheduleDetails[${index}].slots`;
                              const touchedFromSlots = getIn(touched, slots);
                              const errorFromSlots = getIn(errors, slots);
                              return (
                                <div key={index}>
                                  <SchedulingModalInner
                                    index={index}
                                    values={data}
                                    errors={errors}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                    touched={touched}
                                    selectedData={selectedData}
                                    bookingFormvalues={formRef?.current?.values}
                                    creativeList={creativeList}
                                    programData={programData}
                                    selectedCreativeIds={selectedCreativeIds}

                                  />
                                  <Index.FormHelperText error>
                                    {errorFromSlots &&
                                      touchedFromSlots &&
                                      errorFromSlots}
                                  </Index.FormHelperText>
                                  <Index.Box className="btn-main-primary orange-btn-main add-row-flex">
                                    {index ===
                                    values?.scheduleDetails?.length - 1 ? (
                                      <Index.Box className="admin-add-creative-btn-row btn-main-primary">
                                        <Index.Button
                                          className="admin-modal-user-btn btn-primary"
                                          onClick={() => {
                                            push({
                                              type: "dateRange",
                                              startDate:
                                                formRef?.current?.values
                                                  ?.startDate ?? null,
                                              endDate:
                                                formRef?.current?.values
                                                  ?.endDate ?? null,
                                              scheduleType: "program",
                                              creative: undefined,
                                              selectedDates: [],
                                              scheduleId:
                                                selectedData?.schedule,
                                              program: undefined,
                                              slots: [],
                                              weekDays: weekArray?.length
                                                ? weekArray
                                                : [],
                                            });
                                          }}
                                        >
                                          <img
                                            src={PagesIndex.Svg.plus}
                                            className="admin-user-save-icon"
                                            alt="Save"
                                          />
                                          <span>Add New Creative</span>
                                        </Index.Button>
                                      </Index.Box>
                                    ) : (
                                      ""
                                    )}
                                    {values?.scheduleDetails?.length > 1 ? (
                                      <Index.Box className="admin-add-creative-btn-row btn-main-primary">
                                        <Index.Button
                                          className="btn-primary add-event-btn "
                                          onClick={() => remove(index)}
                                        >
                                          <img
                                            src={PagesIndex.Svg.deleteicon}
                                            className="admin-incress-dicress-icon"
                                            alt="Save"
                                          />
                                        </Index.Button>
                                      </Index.Box>
                                    ) : (
                                      ""
                                    )}
                                  </Index.Box>
                                </div>
                              );
                            })
                          }
                        </FieldArray>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box className="modal-footer">
                      <Index.Box className="admin-modal-user-btn-flex">
                        <Index.Box className="admin-save-btn-main btn-main-primary">
                          <Index.Button
                            className="admin-save-user-btn btn-primary"
                            type="submit"
                          >
                            <img
                              src={PagesIndex.Svg.save}
                              className="admin-user-save-icon"
                              alt="Save"
                            ></img>
                            <span>Save</span>
                          </Index.Button>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </form>
              );
            }}
          </PagesIndex.Formik>
        </Index.Modal>
        <Index.Modal
          open={openScheduleEdit}
          onClose={handleCloseScheduleEdit}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="admin-modal"
        >
          <PagesIndex.Formik
            enableReinitialize
            onSubmit={handleAddModalDataEdit}
            initialValues={initialValuesOrderEdit}
            validationSchema={PagesIndex.salesSubOrderModal}
            innerRef={formRefOrderEdit}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              setFieldValue,
            }) => {
              const weekData = values?.scheduleDetails.map((data) =>
                data?.type === "dateRange"
                  ? data?.weekDays?.reduce(
                      (acc, curr) => acc + curr?.total,
                      0
                    ) * data?.creativeDuration
                  : data?.selectedDates?.reduce(
                      (acc, curr) => acc + parseInt(curr?.value),
                      0
                    ) * data?.creativeDuration
              );
              const counts = weekData?.reduce((acc, curr) => acc + curr, 0);
              const selectedCreativeIds = values?.scheduleDetails?.map((row) => row?.creative);
              return (
                <form onSubmit={handleSubmit} noValidate="novalidate">
                  <Index.Box
                    sx={style}
                    className="admin-add-user-modal-inner-main admin-modal-inner order-details-modal-inner"
                  >
                    <Index.Box className="admin-modal-header">
                      <Index.Typography
                        id="modal-modal-title"
                        className="admin-modal-title"
                        variant="h6"
                        component="h2"
                      >
                        {" "}
                        Edit Order Details
                      </Index.Typography>
                      <Index.Button
                        className="modal-close-btn"
                        onClick={handleCloseScheduleEdit}
                      >
                        <img
                          src={PagesIndex.Svg.closeblack}
                          className="admin-modal-close-icon"
                          alt="Close"
                        />
                      </Index.Button>
                    </Index.Box>
                    <Index.Box className="grid-row view-order-row">
                      <Index.Box
                        display="grid"
                        gridTemplateColumns="repeat(12, 1fr)"
                        gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                      >
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="order-inner-box">
                            <Index.Typography className="order-inner-lable-text">
                              Platform Name:{" "}
                            </Index.Typography>
                            <Index.Typography className="order-inner-value-text">
                              {selectedData?.platform}
                            </Index.Typography>
                          </Index.Box>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 8",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="order-inner-box">
                            <Index.Typography className="order-inner-lable-text">
                              Element:{" "}
                            </Index.Typography>
                            <Index.Typography className="order-inner-value-text">
                              {selectedData?.elements}
                            </Index.Typography>
                          </Index.Box>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 8",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="order-inner-box">
                            <Index.Typography className="order-inner-lable-text">
                              Total Remaining Units:{" "}
                            </Index.Typography>
                            <Index.Typography className="order-inner-value-text">
                              {selectedData?.orgRemainingUnits +
                                selectedData?.units -
                                counts || 0}
                            </Index.Typography>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
                      <Index.Box className="order-show-box">
                        <FieldArray name="scheduleDetails">
                          {() =>
                            values?.scheduleDetails?.map((data, index) => {
                              const slots = `scheduleDetails[${index}].slots`;
                              const touchedFromSlots = getIn(touched, slots);
                              const errorFromSlots = getIn(errors, slots);
                              return (
                                <div key={index}>
                                  <SchedulingModalInnerEdit
                                    adminDetails={adminDetails}
                                    index={index}
                                    values={data}
                                    errors={errors}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                    touched={touched}
                                    selectedData={selectedData}
                                    orderList={orderList}
                                    creativeList={creativeList}
                                    programData={programData}
                                    selectedCreativeIds={selectedCreativeIds}
                                  />
                                  <Index.FormHelperText error>
                                    {errorFromSlots &&
                                      touchedFromSlots &&
                                      errorFromSlots}
                                  </Index.FormHelperText>
                                </div>
                              );
                            })
                          }
                        </FieldArray>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box className="modal-footer">
                      <Index.Box className="admin-modal-user-btn-flex">
                        <Index.Box className="admin-save-btn-main btn-main-primary">
                          <Index.Button
                            className="admin-save-user-btn btn-primary"
                            type="submit"
                            disabled={buttonSpinner}
                          >
                            {buttonSpinner ? (
                              <PagesIndex.Spinner />
                            ) : (
                              <>
                                <img
                                  src={PagesIndex.Svg.save}
                                  className="admin-user-save-icon"
                                  alt="Save"
                                ></img>
                                <span>Save</span>
                              </>
                            )}
                          </Index.Button>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </form>
              );
            }}
          </PagesIndex.Formik>
        </Index.Modal>
        <Index.Modal
          open={openScheduleView}
          onClose={handleCloseScheduleView}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="admin-modal"
        >
          <PagesIndex.Formik
            enableReinitialize
            onSubmit={() => {}}
            initialValues={initialValuesOrder}
            validationSchema={PagesIndex.salesSubOrderModal}
          >
            {({ values }) => (
              <Index.Box
                sx={style}
                className="admin-add-user-modal-inner-main admin-modal-inner order-details-modal-inner"
              >
                <Index.Box className="admin-modal-header">
                  <Index.Typography
                    id="modal-modal-title"
                    className="admin-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    {" "}
                    View Order Details
                  </Index.Typography>
                  <Index.Button
                    className="modal-close-btn"
                    onClick={handleCloseScheduleView}
                  >
                    <img
                      src={PagesIndex.Svg.closeblack}
                      className="admin-modal-close-icon"
                      alt="Close"
                    />
                  </Index.Button>
                </Index.Box>
                <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
                  <Index.Box className="order-show-box">
                    <Index.Box className="grid-row view-order-row">
                      <Index.Box
                        display="grid"
                        gridTemplateColumns="repeat(12, 1fr)"
                        gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                      >
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="order-inner-box">
                            <Index.Typography className="order-inner-lable-text">
                              Platform Name:{" "}
                            </Index.Typography>
                            <Index.Typography className="order-inner-value-text">
                              {selectedData?.platform}
                            </Index.Typography>
                          </Index.Box>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 8",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="order-inner-box">
                            <Index.Typography className="order-inner-lable-text">
                              Element:{" "}
                            </Index.Typography>
                            <Index.Typography className="order-inner-value-text">
                              {selectedData?.elements}
                            </Index.Typography>
                          </Index.Box>
                        </Index.Box>

                        {/* <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 8",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="order-inner-box">
                            <Index.Typography className="order-inner-lable-text">
                              Total Remaining Units:{" "}
                            </Index.Typography>
                            <Index.Typography className="order-inner-value-text">
                              {selectedData?.remainingUnits}
                            </Index.Typography>
                          </Index.Box>
                        </Index.Box> */}
                      </Index.Box>
                    </Index.Box>
                    <FieldArray name="scheduleDetails">
                      {() =>
                        values?.scheduleDetails?.map((data, index) => {
                          return (
                            <div key={index}>
                              <SchedulingModalInnerView
                                index={index}
                                values={data}
                                selectedData={selectedData}
                                orderList={orderList}
                                creativeList={creativeList}
                                programData={programData}
                              />
                            </div>
                          );
                        })
                      }
                    </FieldArray>
                  </Index.Box>
                </Index.Box>
                <Index.Box className="modal-footer">
                  <Index.Box className="admin-modal-user-btn-flex">
                    <Index.Box className="admin-save-btn-main btn-main-primary">
                      <Index.Button
                        className="admin-save-user-btn btn-primary"
                        onClick={handleCloseScheduleView}
                      >
                        <span>Close</span>
                      </Index.Button>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            )}
          </PagesIndex.Formik>
        </Index.Modal>
        <Index.Modal
          open={openSave}
          onClose={handleCloseSave}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="admin-modal"
        >
          <Index.Box
            sx={style}
            className="admin-delete-modal-inner-main admin-modal-inner"
          >
            <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
              <Index.Typography
                className="admin-delete-modal-title"
                component="h2"
                variant="h2"
              >
                Are you sure?
              </Index.Typography>
              <Index.Typography
                className="admin-delete-modal-para admin-common-para"
                component="p"
                variant="p"
              >
                Do you really want to save this order? This process cannot be
                undone.
              </Index.Typography>
              <Index.Box className="admin-delete-modal-btn-flex border-btn-main btn-main">
                <Index.Button
                  className="admin-modal-cancel-btn border-btn"
                  onClick={handleCloseSave}
                  disabled={buttonSpinner}
                >
                  Cancel
                </Index.Button>
                <Index.Button
                  className="delete-user admin-modal-delete-btn btn"
                  onClick={() => handleAddData(formRef?.current?.values)}
                  disabled={buttonSpinner}
                >
                  {buttonSpinner ? <PagesIndex.Spinner /> : <span>Save</span>}
                </Index.Button>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Modal>
        <Index.Modal
          open={openDiscard}
          onClose={handleCloseDiscard}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="admin-modal"
        >
          <Index.Box
            sx={style}
            className="admin-delete-modal-inner-main admin-modal-inner"
          >
            <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
              <Index.Box className="admin-modal-circle-main">
                <img
                  src={PagesIndex.Svg.closecircle}
                  className="admin-user-circle-img"
                  alt="Close"
                />
              </Index.Box>
              <Index.Typography
                className="admin-delete-modal-title"
                component="h2"
                variant="h2"
              >
                Are you sure?
              </Index.Typography>
              <Index.Typography
                className="admin-delete-modal-para admin-common-para"
                component="p"
                variant="p"
              >
                Do you really want to discard this order?
              </Index.Typography>
              <Index.Box className="admin-delete-modal-btn-flex border-btn-main btn-main">
                <Index.Button
                  className="admin-modal-cancel-btn border-btn"
                  onClick={handleCloseDiscard}
                  disabled={buttonSpinner}
                >
                  Cancel
                </Index.Button>
                <Index.Button
                  className="delete-user admin-modal-delete-btn btn"
                  onClick={() => navigate("/admin/sales-order-list")}
                  disabled={buttonSpinner}
                >
                  {buttonSpinner ? (
                    <PagesIndex.Spinner />
                  ) : (
                    <span>Discard</span>
                  )}
                </Index.Button>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Modal>
        <Index.Modal
          open={openLogModal}
          onClose={handleCloseLogModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="admin-modal"
        >
          <Index.Box
            sx={style}
            className="admin-log-modal-inner-main admin-modal-inner"
          >
            <Index.Box className="admin-modal-header">
              <Index.Typography
                id="modal-modal-title"
                className="admin-modal-title"
                variant="h6"
                component="h2"
              >
                {" "}
                Activity Log
              </Index.Typography>
              <Index.Button
                className="modal-close-btn"
                onClick={handleCloseLogModal}
              >
                <img
                  src={PagesIndex.Svg.closeblack}
                  className="admin-modal-close-icon"
                  alt="Close"
                />
              </Index.Button>
            </Index.Box>
            <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
              <Index.Box className="common-card">
                <Index.Box className="page-table-main category-activity-table-main">
                  <Index.TableContainer
                    component={Index.Paper}
                    className="table-container"
                  >
                    {activityLoading ? (
                      <PagesIndex.Loader />
                    ) : (
                      <Index.Table aria-label="simple table" className="table">
                        <Index.TableHead className="table-head">
                          <Index.TableRow className="table-row">
                            <Index.TableCell
                              component="th"
                              variant="th"
                              className="table-th"
                              width="70%"
                            >
                              Activity
                            </Index.TableCell>

                            <Index.TableCell
                              component="th"
                              variant="th"
                              className="table-th"
                              width="30%"
                            >
                              Updated By
                            </Index.TableCell>
                          </Index.TableRow>
                        </Index.TableHead>
                        <Index.TableBody className="table-body">
                          {renderActivityLogContent()}
                        </Index.TableBody>
                      </Index.Table>
                    )}
                  </Index.TableContainer>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Modal>
      </>
    </Index.Box>
  );
}

const TableData = ({
  data,
  handleOpenSchedule,
  handleOpenScheduleView,
  formRef,
}) => {
  return data?.length ? (
    data?.map((data, index) => {
      return (
        <Index.TableRow
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          key={data?._id}
        >
          <Index.TableCell component="td" variant="td" className="table-td">
            <Index.Typography className="admin-table-data-text">
              {index + 1}
            </Index.Typography>
          </Index.TableCell>

          <Index.TableCell component="td" variant="td" className="table-td">
            <Index.Typography className="admin-table-data-text">
              {data?.platform ? data?.platform : "-"}
            </Index.Typography>
          </Index.TableCell>

          <Index.TableCell component="td" variant="td" className="table-td">
            <Index.Typography className="admin-table-data-text">
              {data?.elements ? data?.elements : "-"}
            </Index.Typography>
          </Index.TableCell>

          <Index.TableCell component="td" variant="td" className="table-td">
            <Index.Typography className="admin-table-data-text">
              {data?.totalSeconds ? data?.totalSeconds : 0} ({data?.unit})
            </Index.Typography>
          </Index.TableCell>

          <Index.TableCell component="td" variant="td" className="table-td">
            <Index.Typography className="admin-table-data-text">
              {" "}
              {data?.discountrate ? data?.discountrate : 0}
            </Index.Typography>
          </Index.TableCell>

          <Index.TableCell component="td" variant="td" className="table-td">
            <Index.Typography className="admin-table-data-text">
              {parseFloat(data?.remainingUnits)}
            </Index.Typography>
          </Index.TableCell>
          <Index.TableCell
            component="td"
            variant="td"
            scope="row"
            className="table-td"
          >
            {data?.platform === "TV FCT" || data?.platform === "TV Non FCT" ? (
              <Index.Box className="input-cus-flex">
                <Index.Tooltip
                  title={"Schedule"}
                  arrow
                  placement="bottom"
                  className="admin-tooltip"
                >
                  <Index.Button
                    className="schedule-btn view-schedule-btn border-btn"
                    disabled={parseFloat(data?.orgRemainingUnits) === 0}
                    onClick={() => {
                      if (
                        formRef?.current?.values?.name &&
                        formRef?.current?.values?.startDate &&
                        formRef?.current?.values?.endDate
                      ) {
                        handleOpenSchedule(data, index);
                      } else {
                        PagesIndex.toasterError(
                          "Please fill out all the booking details before scheduling"
                        );
                      }
                    }}
                  >
                    <img
                      src={PagesIndex.Svg.calendaricon}
                      className="admin-icons"
                      alt="discard"
                    />
                  </Index.Button>
                </Index.Tooltip>
                <Index.Tooltip
                  title={"View"}
                  arrow
                  placement="bottom"
                  className="admin-tooltip"
                >
                  <Index.Button
                    className="schedule-btn view-schedule-btn border-btn"
                    disabled={
                      !(
                        formRef?.current?.values?.name &&
                        formRef?.current?.values?.startDate &&
                        formRef?.current?.values?.endDate
                      ) || parseFloat(data?.orgRemainingUnits) === 0
                    }
                    onClick={() => handleOpenScheduleView(data, index)}
                  >
                    <img
                      src={PagesIndex.Svg.yelloweye}
                      className="admin-icons"
                      alt="discard"
                    />
                  </Index.Button>
                </Index.Tooltip>
              </Index.Box>
            ) : (
              "-"
            )}
          </Index.TableCell>
        </Index.TableRow>
      );
    })
  ) : (
    <PagesIndex.DataNotFound />
  );
};
